import { Form, Checkbox, Input, Anchor } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_icmawrs_form } from "../../actions/form_slice";
import { debounce } from "lodash";
const { Link } = Anchor;

const ICMAWRS = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.icmawrs_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_icmawrs_form(changedValues));
    onValuesChange(formData);
  }, 300);

  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="vertical"
      labelWrap
      //   wrapperCol={{
      //     flex: 1,
      //   }}
    >
      <Form.Item
        valuePropName="checked"
        name="Read and Reviewed Mandatory ABAWD / E&T / Work Registrant Scripts (E-26) with Client"
      >
        <Checkbox value="Read and Reviewed Mandatory ABAWD / E&T / Work Registrant Scripts (E-26) with Client">
          {
            <a
              href="https://content.dcf.ks.gov/ees/KEESM/Appendix/E-26 - Consolidated Work Requirements (English).pdf"
              target="_blank"
            >
              Mandatory ABAWD / E&T / Work Registrant Scripts
            </a>
          }
          (E-26) with Client
        </Checkbox>
      </Form.Item>

      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
    </Form>
  );
});
export default ICMAWRS;
